export const getName = (firstName: string = '', lastName: string = ''): string =>
  !!lastName ? `${firstName} ${lastName}` : firstName;
